<template>
    <section class="section section-shaped section-lg my-0">
        <div class="shape shape-style-1 bg-gradient-default">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="container pt-lg-md">
            <div class="row justify-content-center">
              <!-- Content Start -->
              <div class="col-lg-8 col-md-10 mx-auto">
                <h1 class="post-heading">日本でこれからスタートアップのM＆Aイグジットが増える理由
</h1>	

                <span class="meta"> Posted in March 2023 </span>

                <figure>
                  <img class="img-fluid" src="img/blog/card/japan-startup-m&a.jpg" alt="">
                </figure>
                
<p>Shizen Capital では、日本のアーリーステージ・スタートアップのイグジットに関する見解を、投資方針の重要な構成要素の一つとしている。我々は、日本が今、変曲点に達し、日本のスタートアップの M&A は銀河系に向かう準備ができていると考えている。</p>
<p>歴史的に見ると、IPO は日本の VC が支援するスタートアップがイグジットする最も一般的で実行可能な方法であった。東京証券取引所のマザーズ市場（現在は、グロース市場に改称）は、評価額1,000万米ドル台のマイクロキャップ企業でも株式公開が可能なほど機能的だ。これは諸刃の剣であることが証明されており、この話題についてはもっと長い記事で詳しく説明する必要があるだろう。</p>
<p>（長文が苦手な人への要約：マイクロキャップ上場の主なメリットは、VC ファンドに便利なイグジットを提供することだが、欠点がないわけではない。例えば、未公開企業の野心を抑え、IPO 準備サービス業者との不整合リスクを生み出し、起業家世代を上場企業の管理者にすることを強いて、日本の VC から、優れた VC であるために最も重要な技術の一つ——スタートアップの M&A を視野に入れること——を学ぶ機会を奪っている。)</p>
<p>逆説的だが、我々の日本でのファンドからのイグジットは、私自身の自己最高記録を含めて、すべて M&A で行われている。我々の日本での実績は例外的なようだが、日本のスタートアップの M&A はこれから飛躍的に増えていくと考えている。その背景には3つの要因があると思う。</p>
<p>1. 創業者の心理変化</p>
<p>M&A で会社を売却することは、もはや失敗を認めることではない、という視点が、日本の創業者の間で、まぎれもなく変化していることがわかる。この文章の最後を読んで驚かれるなら、私自身も驚いた。私が日本で最初のファンドを立ち上げたときに発見したことは、日本の創業者は、IPO を成功の証と考え、会社を他の会社に売ることは、自分たちが成功できないことを意味すると教育されてきたということだ。M&A は最低でもプラン B と見なされていたのだ。</p>
<p>幸いなことに、この考え方は変わりつつある。この考え方の変化の具体的な理由を特定することはできないが、私はいくつかの要因があると思う。日本では、IPO を目指すスタートアップ創業者の数が限界に達しているのかもしれない。そのような創業者は、上場企業の経営に携わり、上場にはコンプライアンス遵守や IR の義務が伴うが、起業家としての生活とはかけ離れた日常的な責任を負わされることで、新たな経営者としての役割に不満を持っている。そのような人たちは、「0から1を生み出す」起業家として、自分の本質的な動機と調和しながら、ただいじり、作り上げることができた日々を懐かしみ、今が惨めであると打ち明けているのだ。</p>
<p>また、M&A に関連する感情的な荷物を持たず、模範となるような外国人起業家が日本に増えていることも、認識変化の一因と考えられる。</p>
<p>2. 国内スタートアップを買収した企業への税制優遇措置</p>
<p>日本政府が掲げる「スタートアップ国家」への取り組みの一環として、日本企業が国内のスタートアップを買収する際の税制上の優遇措置が新たに設けられた。この新制度では、1件あたり50億円を上限に、買収額の25％を課税所得から控除することができ、年間合計で125億円の税額控除が可能になる。</p>
<p>この新しい税額控除は、多くの日本企業に蔓延する「NIH 症候群 （自前主義）」を克服するのに役立つだろう。これは、企業内のインセンティブを揺るがす可能性がある。この税額控除を利用する企業が現れれば、他の企業もそれに倣い、M&A を活発化させることだろう（筆者注：のれん代の償却については若干の問題が残るが、現在検討が続けられている）。</p>
<p>3. インフレの新しいマクロ経済パラダイム</p>
<p>日本にもインフレが到来した。他の G7 諸国ほどではないが、日本は最近、41年ぶりの高水準となる4.3％近いインフレ率を記録している。そのため、企業経営者の間では、この新しいインフレ環境に対する感度が高まっている。バランスシート上に3兆米ドル以上のキャッシュを抱える日本企業は、長年の懸案であったデジタルトランスフォーメーションへの投資を加速させるか、インフレで資金が目減りする中で逡巡するか、以前に増して明白な選択を余儀なくされる機会に直面している。</p>
<p>我々は、ここに書いたような要因が好循環をもたらすと信じている。アーリーステージのベンチャー企業に対する M&A の増加は、新世代の創業者に、適度な富の創造を伴う会社作りを体験させることになるだろう。ヨーロッパのエコシステムの経験を参考にすれば、この最初の一歩が、成功した創業者の一部を再び起業に向かわせ、さらなる高みを目指す動機付けとなる可能性がある。また、アーリーステージのベンチャーキャピタルになる人もいるかもしれない。</p>
<p>このような状況は、日本におけるアーリーステージ・ベンチャー投資全体にとって好ましいことであると我々は考えている。</p>


              </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {};
</script>
<style>
.post-heading,
.subheading,
.section-heading,
.blockquote,
.meta,
p,
span {
  color: #fff;
}
.post-heading {
  font-size: 20px;
  font-weight: 700;
  line-height: 1;
}
.subheading {
  font-size: 20px;
  margin-top: 16px;
}
.section-heading {
  font-weight: 700;
  margin-top: 32px;
}
.section-heading + p {
  margin-top: 16px;
}
.meta + p {
  margin-top: 32px;
}
.author-info {
  font-size: 14px;
  font-style: italic;
  line-height: 1.5;
}
figure {
  margin-top: 24px;
}
</style>

